import { createElement, Component, Props as ReactProps } from 'react';

import { DependencyProps } from '../../../core/dependency';
import { LocationProps } from '../../../core/location';
import { StateProps } from '../../../core/state';

type Props = ReactProps<HTMLElement> & DependencyProps & StateProps & LocationProps;
type State = {};

class SigninRoute extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
  }

  public render() {
    const { currentUser, currentStore } = this.props.state;
    if (currentUser) {
      return (
        <a href={currentStore && currentStore.mypageUri || ''}>{currentUser.name || currentUser.email}</a>
      )
    } else {
      return (
        <a href={currentStore && currentStore.signinUri || ''}>ログイン</a>
      )
    }
  }
}

export default SigninRoute;
